import { store } from '@/firebase'
import {
  availableBookingCount,
  CollectionName,
  FSStripeProSubscription,
  FSUserPlan
} from '@WombatTechnology/nitte-time-lib'
import {
  collection,
  CollectionReference,
  doc,
  DocumentReference,
  getDoc,
  Timestamp
} from 'firebase/firestore'

export class UserPlan {
  constructor(
    readonly uid: string,
    readonly ref: DocumentReference<
      FSUserPlan<
        Timestamp,
        DocumentReference<FSStripeProSubscription<Timestamp>>
      >
    >,
    readonly data: FSUserPlan<
      Timestamp,
      DocumentReference<FSStripeProSubscription<Timestamp>>
    >
  ) {}

  get plan() {
    return this.data.plan
  }

  get planConsideringProTrial() {
    if (this.plan === 'team') {
      return 'team'
    }
    if (this.plan === 'pro') {
      return 'pro'
    }
    return this.freeTrialExpired ? 'free' : 'pro'
  }

  get freeTrialExpired() {
    return (
      this.data.freeTrialExpireAt &&
      this.data.freeTrialExpireAt.toMillis() < Date.now()
    )
  }

  get availableBookingCount() {
    return availableBookingCount(this.data)
  }

  static async build(uid: string) {
    const userPlan = await getDoc(this.doc(uid))
    return new UserPlan(uid, this.doc(uid), userPlan.data()!)
  }

  static doc(uid: string) {
    return doc(this.collection(), uid)
  }

  static collection() {
    return collection(
      store,
      `${CollectionName.UserPlans}`
    ) as CollectionReference<
      FSUserPlan<
        Timestamp,
        DocumentReference<FSStripeProSubscription<Timestamp>>
      >
    >
  }

  static planConsideringFreeTrial(
    userPlan: FSUserPlan<
      Timestamp,
      DocumentReference<FSStripeProSubscription<Timestamp>>
    >
  ) {
    const { plan } = userPlan

    if (plan === 'team') {
      return 'team'
    }
    if (plan === 'pro') {
      return 'pro'
    }
    return null
  }
}
